module.exports = __webpack_public_path__ + "static/media/30.29ce7952.png";